export const CUSTOM_TAGS_NAME = {
  pdp: 'pdp',
  pdp_description: 'pdp-description',
  shop_id: 'shop_id',
  catalog_product_id: 'catalog_product_id',
  is_all_images_error_occurred: 'is_all_images_error_occurred',
  iframe_url: 'iframe_url',
} as const;

export const CUSTOM_TAGS_VALUE = {
  image_error: 'image-error',
  error_boundary: 'error_boundary',
  iframe_url_blocked: 'iframe_url_blocked',
} as const;
